// @flow
import ElJurFooter from './ElJurFooter';

export default ElJurFooter;
